import { DevicePropertyTarget } from '@app/@core/@models/targeting/device-property-target.model';
import { NamedLocationTarget } from '@app/@core/@models/targeting/named-location-target.model';
import {CategoryTarget} from '@app/@core/@models/targeting/category-target.model';
import {KeywordTarget} from '@app/@core/@models/targeting/keyword-target.model';
import {SemanticTarget} from '@app/@core/@models/targeting/semantic-target.model';
import {SiteTarget} from '@app/@core/@models/targeting/site-target.model';
import { UserSegmentTarget } from './user-segment-targets.model';
import { DomainNameTarget } from '@app/@core/@models/targeting/domain-name-target.model';
import {SiteGroupTarget} from "@app/@core/@models/targeting/site-group-target.model";

// ng.model.Targeting also ng.model.ProductCreativeTargeting
export interface Targeting {
  deviceTargets: DevicePropertyTarget[];
  namedLocationTarget: NamedLocationTarget;
  categoryTargets: CategoryTarget[];
  keywordTargets: KeywordTarget[];
  semanticTargets: SemanticTarget[];
  siteTarget: SiteTarget;
  siteGroupTarget: SiteGroupTarget;
  domainNameTarget: DomainNameTarget;
  userSegmentTargets: UserSegmentTarget[];
}

export function getTargetingCounts(targeting: Targeting): Map<string, number> {
  const targetingCounts = new Map<string, number>();
  targetingCounts.set('deviceTargets', targeting.deviceTargets.length);
  targetingCounts.set('namedLocationTarget', targeting.namedLocationTarget.locations.length);
  targetingCounts.set('categoryTargets', targeting.categoryTargets.length);
  targetingCounts.set('keywordTargets', targeting.keywordTargets.length);
  targetingCounts.set('semanticTargets', targeting.semanticTargets.length);
  targetingCounts.set('siteTarget', targeting.siteTarget.sites.length);
  targetingCounts.set('siteGroupTarget', targeting.siteGroupTarget.siteGroups.length);
  targetingCounts.set('domainNameTarget', targeting.domainNameTarget.names.length);
  targetingCounts.set('userSegmentTarget', targeting.userSegmentTargets.length);
  return targetingCounts;
}
